export const GET_MY_TRANSACTIONS_REQUEST = 'GET_MY_TRANSACTIONS_REQUEST';
export const GET_MY_TRANSACTIONS_SUCCESS = 'GET_MY_TRANSACTIONS_SUCCESS';
export const GET_MY_TRANSACTION_DETAILS_SUCCESS = 'GET_MY_TRANSACTION_DETAILS_SUCCESS';
export const RESET_TRANSACTION_DETAILS_SUCCESS = 'RESET_TRANSACTION_DETAILS_SUCCESS';
